import { useEffect } from 'react';

import { noop } from '../../type';

import isAndroid from './isAndroid';

const AutoScrollIntoViewForAndroid = () => {
  const scrollIntoView = () => {
    const { activeElement } = document;

    if (activeElement instanceof HTMLElement) {
      if (
        activeElement.tagName === 'INPUT' ||
        activeElement.tagName === 'TEXTAREA'
      ) {
        activeElement.scrollIntoView();
      }
    }
  };

  useEffect(() => {
    if (!isAndroid()) {
      return noop;
    }

    window.addEventListener('resize', scrollIntoView);
    return () => window.removeEventListener('resize', scrollIntoView);
  });

  return null;
};

export default AutoScrollIntoViewForAndroid;
